module.exports = __webpack_public_path__ + "img/characterAnime24.fc1a49e4.png";